import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { getUiLang } from "../../utils/uiLanguage";
import copy from "./homeCopy";
import eggImg from "../../assets/img/2 MAIN SCREENS EN/home/egg-4x.webp";

export const hideScroll = {
  "&::-webkit-scrollbar": { display: "none" },
  scrollbarWidth: "none",
};

export const sectionPx = 0;

export function useLangCopy() {
  const [lang, setLang] = useState(getUiLang());
  useEffect(() => {
    const onChange = () => setLang(getUiLang());
    window.addEventListener("ga-ui-lang", onChange);
    return () => window.removeEventListener("ga-ui-lang", onChange);
  }, []);
  return copy[lang];
}

export function useUiLang() {
  const [lang, setLang] = useState(getUiLang());
  useEffect(() => {
    const onChange = () => setLang(getUiLang());
    window.addEventListener("ga-ui-lang", onChange);
    return () => window.removeEventListener("ga-ui-lang", onChange);
  }, []);
  return lang;
}

export function SectionTitle({ children }) {
  return (
    <Typography
      sx={{
        fontFamily: "'Rajdhani', sans-serif",
        fontWeight: 700,
        fontSize: { xs: 26, md: 28, lg: 32 },
        letterSpacing: "2px",
        lineHeight: 1.2,
        color: "#FFFFFF",
        px: sectionPx,
      }}
    >
      {children}
    </Typography>
  );
}

export function SectionSub({ children }) {
  return (
    <Typography
      sx={{
        fontFamily: "'Poppins', sans-serif",
        fontSize: { xs: 12.5, md: 14 },
        lineHeight: "17px",
        color: "#9AA88A",
        px: sectionPx,
        mt: "6px",
      }}
    >
      {children}
    </Typography>
  );
}

export function OutlineButton({ label, onClick }) {
  return (
    <Box
      component="button"
      onClick={onClick}
      sx={{
        position: "relative",
        width: "100%",
        maxWidth: "none",
        height: { xs: 45, md: 48 },
        border: "1px solid #262B1C",
        background: "transparent",
        cursor: "pointer",
        mx: 0,
        p: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        clipPath: "polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 0 100%)",
      }}
    >
      <Typography
        sx={{
          position: "relative",
          fontFamily: "'Rajdhani', sans-serif",
          fontWeight: 700,
          fontSize: 14,
          letterSpacing: "2.5px",
          color: "#B8EE3C",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}

export function EggBadge({ size = 15 }) {
  return (
    <Box
      component="img"
      src={eggImg}
      alt=""
      sx={{ width: size, height: size * 1.2, objectFit: "contain" }}
    />
  );
}

export function PlusEgg() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
        background: "#0D0F0A",
        border: "1px solid #262B1C",
        height: 16,
        px: "6px",
      }}
    >
      <Typography
        sx={{
          fontFamily: "'Rajdhani', sans-serif",
          fontWeight: 700,
          fontSize: 9,
          color: "#B8EE3C",
          lineHeight: "11px",
        }}
      >
        +1
      </Typography>
      <EggBadge size={10} />
    </Box>
  );
}

export function useCountdown() {
  const [value, setValue] = useState("00:00:00");
  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const utc = now.getTime() + now.getTimezoneOffset() * 60000;
      const pkt = new Date(utc + 5 * 3600000);
      const end = new Date(pkt);
      end.setHours(24, 0, 0, 0);
      const remaining = Math.max(0, Math.floor((end - pkt) / 1000));
      const h = String(Math.floor(remaining / 3600)).padStart(2, "0");
      const m = String(Math.floor((remaining % 3600) / 60)).padStart(2, "0");
      const s = String(remaining % 60).padStart(2, "0");
      setValue(`${h}:${m}:${s}`);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);
  return value;
}
